import { FC, useCallback } from 'react';
import { Formik } from 'formik';
import { useFragment, useMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import DiskCleanupForm from 'components/DiskCleanupForm';

import { useErrorHandler } from 'lib';

import {
  DiskCleanupMutation,
  DiskCleanupMutation$data,
} from '__generated__/DiskCleanupMutation.graphql';
import { DiskCleanup_data$key } from '__generated__/DiskCleanup_data.graphql';

export type PackageScanParams = {
  expiredBefore: number;
  keepMainPhoto: boolean;
};

type FormValues = {
  packages: {
    selected: boolean;
    config: PackageScanParams;
  };

  storage: {
    selected: boolean;
  };

  media: {
    selected: boolean;
  };
};

const initial: FormValues = {
  packages: {
    selected: false,
    config: {
      expiredBefore: 1,
      keepMainPhoto: true,
    },
  },

  storage: {
    selected: false,
  },

  media: {
    selected: false,
  },
};

export type DiskCleanupFormValues = FormValues;

type Props = {
  data: DiskCleanup_data$key;
};

const DiskCleanup: FC<Props> = props => {
  const errorHandler = useErrorHandler<DiskCleanupMutation$data>();

  const data = useFragment(
    graphql`
      fragment DiskCleanup_data on Query {
        ...DiskCleanupForm_data
      }
    `,
    props.data
  );

  const [clean, cleanLoading] = useMutation<DiskCleanupMutation>(graphql`
    mutation DiskCleanupMutation($input: DiskCleanerInput) {
      diskCleanerClean(input: $input) {
        total {
          count
          size
        }
      }
    }
  `);

  const handleSubmit = useCallback(
    (input: FormValues) => {
      clean({
        variables: { input },

        ...errorHandler({
          successMessage: ({
            diskCleanerClean: {
              total: { count, size },
            },
          }) => `Ištrinta elementų: ${count} , atlaisvinta vietos ${size}`,
        }),
      });
    },
    [clean, errorHandler]
  );

  return (
    <Formik<FormValues> initialValues={initial} onSubmit={handleSubmit}>
      <DiskCleanupForm data={data} loading={cleanLoading} />
    </Formik>
  );
};

export default DiskCleanup;
